import BaseMarker from "./base_marker";

export default class RingMarker extends BaseMarker {
  static anchor() {
    return "center";
  }

  static allowIconFillInjection() {
    return true;
  }

  static iconStyle() {
    return {
      "width": "14px",
      "position": "absolute",
      "left": "13px",
      "top": "13px",
    };
  }

  static iconSvgAttributes() {
    return { "fill": "#8a6bee" };
  }

  static markerStyle() {
    return { "width": "40px" };
  }

  static markerSvgAttributes() {
    return {
      "fill": "#8a6bee",
      "stroke": "#b8a6f4",
      "stroke-width": 2,
      "stroke-opacity": 1
    };
  }

  static markerType() {
    return "ring";
  }

  static dimensions() {
    return {
      "width": 40,
      "height": 40
    }
  }

  static popupOffsets() {
    return {
      'top': [0, this.dimensions().height / 2],
      'top-left': [0, this.dimensions().height / 2],
      'top-right': [0, this.dimensions().height / 2],
      'bottom': [0, -this.dimensions().height / 2],
      'bottom-left': [0, -this.dimensions().height / 2],
      'bottom-right': [0, -this.dimensions().height / 2],
      'left': [this.dimensions().width / 2, 0],
      'right': [(this.dimensions().width / 2) * -1, 0]
    };
  }
}
